<template>
  <div>
    <img class="banner" :src="selectBanner()"> 
    <div class="navList">
        <div class="navContainer">
            <ul>
                <li :class="$route.name=='enterpriseIntroduction'?'nav-active':'nav-default'" @click="$router.push('/aboutUs/enterpriseIntroduction')">企业简介</li>
                <li :class="$route.name=='enterpriseCulture'?'nav-active':'nav-default'" @click="$router.push('/aboutUs/enterpriseCulture')">企业文化</li>
                <li :class="$route.name=='developmentHistory'?'nav-active':'nav-default'" @click="$router.push('/aboutUs/developmentHistory')">发展历程</li>
                <li :class="$route.name=='honor'?'nav-active':'nav-default'" @click="$router.push('/aboutUs/honor')">资质荣誉</li>
                <!-- <li :class="$route.name=='laboratory'?'nav-active':'nav-default'" @click="$router.push('/aboutUs/laboratory')">健安德实验室</li> -->
                <li :class="$route.name=='contactUs'?'nav-active':'nav-default'" @click="$router.push('/aboutUs/contactUs')">联系我们</li>
            </ul>
        </div>
    </div>
    <div class="content typeArea">
        <breadcrumb class="breadcrumb"></breadcrumb>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'aboutUsLayout',
  data () {
    return {}
  },
  methods: {
    selectBanner(){
        if(this.$route.name=='enterpriseIntroduction'){
            return require('@/assets/images/image31.png')
        }else if(this.$route.name=='enterpriseCulture'){
            return require('@/assets/images/image125.png')
        }else if(this.$route.name=='developmentHistory'){
            return require('@/assets/images/image126.png')
        }else if(this.$route.name=='honor'){
            return require('@/assets/images/image127.png')
        }else if(this.$route.name=='laboratory'){
            return require('@/assets/images/image128.png')
        }else if(this.$route.name=='contactUs'){
            return require('@/assets/images/image129.png')
        }
    }
  }
}
</script> 

<style lang='less' scoped>
    .banner{
        height: 600px;
        width: 100%;
        display: block;
        object-fit: cover;
    }
    .navList{
        box-sizing: border-box;
        border-bottom: 1px solid #CCCCCC;
        height: 80px;
        line-height: 80px;
        .navContainer{
            height: 100%;
            width: 1440px;
            margin: 0 auto;
            ul{
                display: flex;
                height: 100%;
                li{
                    height: 100%;
                    flex-grow: 1;
                    text-align: center;
                    cursor: pointer;
                }
                .nav-default{
                    color: #333333;
                }
                .nav-active{
                    background-color: #DB0000;
                    color: white;
                }
                &>li:hover{
                    background-color: #DB0000;
                    color: white;
                }
            }
        }
    }
    .content{
        .breadcrumb{
            margin: 40px 0 70px 0;
        }
    }
</style>
